import { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useSearchParams } from "react-router-dom";
import OrderFlow from "./OrderFlow";
import { OrderPopups } from "./components/OrderPopups";
import { Popup } from "./components/Popup";
import { Results } from "./components/Results";
import { SearchUseplace } from "./components/Search";
import { SearchBox } from "./components/SearchBox";
import { useStore } from "./stores";

function App() {
  const selectedUseplaceId = useStore((state) => state.selectedUseplaceId);
  let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedUsePlace, setSelectedUsePlace] = useState<number | null>(null);
  const [usePlace, setUsePlace] = useState<null | SearchUseplace>(null);
  const q = searchParams.get("q");

  useEffect(() => {
    if (q) {
      navigate(`/${q}`, { replace: true });
    }
  }, [q]);

  return (
    <div className="font-sans">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div className="bg-secondary-500 py-2 md:py-4">
                <h3 className="my-2 md:my-16 elementor-heading-title elementor-size-default text-center text-white">
                  Se vad vi kan erbjuda dig
                </h3>
              </div>
              <div className="max-w-2xl mx-auto mt-8 relative">
                <SearchBox />
                {selectedUseplaceId ? <Popup /> : <Results />}
              </div>
            </>
            // <Search
            //   setSelectedUsePlace={setSelectedUsePlace}
            //   setUsePlace={setUsePlace}
            // />
          }
        />
        <Route path="/:useplaceId" element={<OrderFlow />} />
        <Route path="/popups" element={<OrderPopups />} />
      </Routes>
      {/* {!selectedUsePlace && (

      )}
      {selectedUsePlace && usePlace && (
        <>
          <div className="bg-blue-700 text-white p-4">
            {usePlace.fulladdress}
          </div>
          <OrderFlow />
        </>
      )} */}
    </div>
  );
}

export default App;
